import { SPEAKERS_COLORS } from "@/constants/style.constants";
import { useCall } from "@/hooks/useCall/useCall";
import { PERMISSIONS_ACTIONS, usePermissions } from "@dashboard/library";

/**
 * Check the permission from dashboard context
 * @returns Whether the connected user has the permission the read a number
 */

export const useHasReadLinePermission = () => {
  const { permissions } = usePermissions();
  return permissions?.CONVERSATIONS_CENTER?.includes(PERMISSIONS_ACTIONS.READ);
};

export const useSpeakerColor = (channel: number) => {
  const { call } = useCall();
  const { variant } = call?.speakers?.get?.(channel) ?? { variant: "green" };

  return SPEAKERS_COLORS[variant];
};
